import show from './show';
import list from './list';
import create from './create';
import edit from './edit';
import icon from '@mui/icons-material/Face';

const UserResources = { show, list, create, edit, icon };

export default UserResources;